export const getTokens = () => {
  const accessToken = localStorage['access_token']
  const refreshToken = localStorage['refresh_token']

  return { accessToken, refreshToken }
}
